import Flatpickr from 'stimulus-flatpickr'
import "flatpickr/dist/flatpickr.css"

// create a new Stimulus controller by extending stimulus-flatpickr wrapper controller
export default class extends Flatpickr {
  initialize() {
    this.config = {}
  }
}
